import { useTranslation } from 'react-i18next';

import { TextInput } from '@/components/ui/daisy';
import { useInputFocus } from '@/data/hook/shared/useInputFocus';
import { QuestionCreateDTO } from '@/models/Answer';

type QuestionColumnItemTextProps = {
  item: QuestionCreateDTO;
  autoFocus?: boolean;
  onUpdateText: (text: string) => void;
};

export default function QuestionColumnItemText({
  item,
  autoFocus,
  onUpdateText,
}: QuestionColumnItemTextProps) {
  const { t: tCommon } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.questionsTab.createQuestionModal.answersCommon',
  });

  const inputRef = useInputFocus<HTMLInputElement>(autoFocus);

  return (
    <TextInput
      ref={inputRef}
      value={item.text ?? ''}
      placeholder={tCommon('newOption')}
      className="w-full"
      onChange={e => onUpdateText(e.target.value)}
    />
  );
}
